function initTracking() {
  const forms = document.querySelectorAll('.tracking-form');
  const errorEl = document.getElementById('tracking-error');
  const resultsContainer = document.getElementById('tracking-results');
  const timelineContainer = document.getElementById('tracking-timeline');
  const splitContainer = document.querySelector('.tracking-split-container');
  
  if (!forms.length || !errorEl || !resultsContainer || !splitContainer) return;

  // Settings
  const workerUrl = splitContainer.getAttribute('data-worker-url');

  // Summary Elements
  const courierEl = document.getElementById('summary-courier');
  const statusEl = document.getElementById('summary-status');
  const deliveryEl = document.getElementById('summary-delivery');
  const routeEl = document.getElementById('summary-route');

  // Stepper Elements
  const stepperWrapper = document.getElementById('tracking-stepper-wrapper');
  const stepperFill = document.getElementById('stepper-progress-fill');
  const deliveryTruck = document.getElementById('delivery-truck');
  const stepNodes = [
    document.getElementById('step-ordered'),
    document.getElementById('step-shipped'),
    document.getElementById('step-out'),
    document.getElementById('step-delivered')
  ];

  // Re-fetch forms after cloning
  const updatedForms = document.querySelectorAll('.tracking-form');
  
  // Cross-disable logic
  const rsForm = document.querySelector('form[data-provider="rapidshyp"]');
  const srForm = document.querySelector('form[data-provider="shiprocket"]');
  if (rsForm && srForm) {
    const rsInput = rsForm.querySelector('input[name="tracking_number"]');
    const srInput = srForm.querySelector('input[name="tracking_number"]');
    const rsCard = rsForm.closest('.tracking-card');
    const srCard = srForm.closest('.tracking-card');
    
    if (rsInput && srInput) {
      const updateCrossDisable = () => {
        if (rsInput.value.trim().length > 0) {
          srInput.value = '';
          srForm.querySelector('button[type="submit"]').disabled = true;
          if (srCard) srCard.classList.add('dimmed');
        } else {
          srForm.querySelector('button[type="submit"]').disabled = false;
          if (srCard) srCard.classList.remove('dimmed');
        }
        
        if (srInput.value.trim().length > 0) {
          rsInput.value = '';
          rsForm.querySelector('button[type="submit"]').disabled = true;
          if (rsCard) rsCard.classList.add('dimmed');
        } else {
          rsForm.querySelector('button[type="submit"]').disabled = false;
          if (rsCard) rsCard.classList.remove('dimmed');
        }
      };

      rsInput.addEventListener('input', updateCrossDisable);
      srInput.addEventListener('input', updateCrossDisable);
      
      // Run once on load in case browser pre-filled
      updateCrossDisable();
      setTimeout(updateCrossDisable, 100);
      setTimeout(updateCrossDisable, 500);
    }
  }

  updatedForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const trackingInput = form.querySelector('.tracking-input');
      const trackingNumber = trackingInput.value.trim();
      
      if (!trackingNumber) return;

      const provider = form.getAttribute('data-provider');
      const btnText = form.querySelector('.tracking-btn-text');
      const spinner = form.querySelector('.tracking-spinner');
      const submitBtn = form.querySelector('.tracking-submit-btn');
      
      // Reset state
      errorEl.classList.add('hidden');
      errorEl.textContent = '';
      resultsContainer.classList.add('hidden');
      if (stepperWrapper) stepperWrapper.classList.add('hidden');
      timelineContainer.innerHTML = '';
      
      // Set loading state
      submitBtn.disabled = true;
      if (btnText) btnText.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');

      try {
        let mappedData = null;

        if (!workerUrl) {
          throw new Error("Cloudflare Worker URL is not configured in Theme Settings.");
        }

        if (provider === 'shiprocket') {
          mappedData = await fetchShiprocket(trackingNumber, workerUrl);
        } else if (provider === 'rapidshyp') {
          mappedData = await fetchRapidShyp(trackingNumber, workerUrl);
        }

        renderTimeline(mappedData);

      } catch (err) {
        errorEl.textContent = err.message || 'Something went wrong. Please try again.';
        errorEl.classList.remove('hidden');
      } finally {
        submitBtn.disabled = false;
        if (btnText) btnText.classList.remove('hidden');
        if (spinner) spinner.classList.add('hidden');
      }
    });
  });

  async function fetchShiprocket(awb, workerUrl) {
    const url = new URL(workerUrl);
    url.searchParams.set('awb', awb);
    url.searchParams.set('courier', 'shiprocket');

    const trackRes = await fetch(url.toString(), {
      method: 'GET'
    });

    if (!trackRes.ok) throw new Error("API Proxy failed to find tracking details.");
    const trackData = await trackRes.json();

    if (!trackData || !trackData.tracking_data || trackData.tracking_data.error) {
       throw new Error(trackData.tracking_data?.error || "Invalid Tracking Number.");
    }

    const tData = trackData.tracking_data;
    const sData = tData.shipment_track && tData.shipment_track[0] ? tData.shipment_track[0] : null;
    const activities = tData.shipment_track_activities || [];

    if (!sData) throw new Error("No shipment details found.");

    return {
      courier: sData.courier_name,
      status: sData.current_status,
      estimated_delivery: sData.expected_date || 'N/A',
      origin: sData.origin || 'N/A',
      destination: sData.destination || 'N/A',
      timeline: activities.map(a => ({
        status: a.activity,
        location: a.location,
        time: a.date,
        is_current: false 
      })).reverse()
    };
  }

  async function fetchRapidShyp(awb, workerUrl) {
    const url = new URL(workerUrl);
    url.searchParams.set('awb', awb);
    url.searchParams.set('courier', 'rapidshyp');
    
    const trackRes = await fetch(url.toString(), {
      method: 'GET'
    });

    if (!trackRes.ok) throw new Error("API Proxy failed to fetch RapidShyp tracking.");
    const data = await trackRes.json();

    if (!data.success || !data.records || data.records.length === 0) {
      throw new Error("RapidShyp couldn't find this tracking number.");
    }

    const record = data.records[0];
    const firstShipment = record.shipment_details && record.shipment_details.length > 0 ? record.shipment_details[0] : null;

    if (!firstShipment) throw new Error("No shipment details found.");

    return {
      courier: firstShipment.courier_name || 'N/A',
      status: firstShipment.current_tracking_status_desc || record.order_status || 'N/A',
      estimated_delivery: firstShipment.edd || 'N/A',
      origin: firstShipment.warehouse_city || 'N/A',
      destination: record.shipping_city || 'N/A',
      timeline: (firstShipment.track_scans || []).map(scan => ({
        status: scan.scan,
        location: scan.scan_location,
        time: scan.scan_datetime
      }))
    };
  }

  function renderTimeline(data) {
    if (courierEl) courierEl.textContent = data.courier || '-';
    if (statusEl) {
        statusEl.textContent = data.status || '-';
        statusEl.className = 'summary-value status-badge';
        const statusLower = (data.status || '').toLowerCase();
        if (statusLower.includes('delivered')) {
          statusEl.classList.add('delivered');
        } else if (statusLower.includes('exception') || statusLower.includes('failed') || statusLower.includes('returned') || statusLower.includes('rto')) {
          statusEl.classList.add('exception');
        }
    }

    if (deliveryEl) deliveryEl.textContent = data.estimated_delivery || '-';
    
    if (routeEl) {
        if (data.origin !== 'N/A' && data.destination !== 'N/A') {
          routeEl.innerHTML = `${data.origin} &rarr; ${data.destination}`;
        } else {
          routeEl.textContent = '-';
        }
    }

    // Process Horizontal Stepper
    if (stepperWrapper) {
      stepperWrapper.classList.remove('hidden');
      
      const statusLower = (data.status || '').toLowerCase();
      let stepIndex = 0; // 0 = Ordered, 1 = Shipped, 2 = Out, 3 = Delivered

      if (statusLower.includes('delivered')) {
        stepIndex = 3;
      } else if (statusLower.includes('out for delivery') || statusLower.includes('out_for_delivery')) {
        stepIndex = 2;
      } else if (statusLower.includes('shipped') || statusLower.includes('transit') || statusLower.includes('dispatched')) {
        stepIndex = 1;
      } else {
        // Pickup generated, new, manifested, etc.
        stepIndex = 0;
      }

      // Hide truck if exception
      if (statusLower.includes('exception') || statusLower.includes('rto') || statusLower.includes('returned') || statusLower.includes('failed')) {
        if (deliveryTruck) deliveryTruck.classList.add('hidden');
      } else {
        if (deliveryTruck) deliveryTruck.classList.remove('hidden');
      }

      const percentages = [0, 33.33, 66.66, 100];
      const targetPercent = percentages[stepIndex];

      // Reset steps
      stepNodes.forEach((node, i) => {
        if (node) {
          node.classList.remove('active', 'completed');
          if (i < stepIndex) node.classList.add('completed');
          if (i === stepIndex) node.classList.add('active');
        }
      });

      // Animate Bar and Truck
      setTimeout(() => {
        if (stepperFill) stepperFill.style.width = `${targetPercent}%`;
        if (deliveryTruck) {
          deliveryTruck.style.left = `${targetPercent}%`;
          if (stepIndex === 3) deliveryTruck.classList.add('hidden'); // hide truck when delivered
        }
      }, 100);
    }

    if (timelineContainer) {
        if (data.timeline && data.timeline.length > 0) {
          data.timeline[0].is_current = true;
          const statusLower = (data.status || '').toLowerCase();

          data.timeline.forEach((item) => {
            const li = document.createElement('li');
            li.className = 'timeline-item';
            
            if (item.is_current) li.classList.add('active');
            if (statusLower.includes('delivered') && item.is_current) li.classList.add('delivered');

            li.innerHTML = `
              <div class="timeline-icon"></div>
              <div class="timeline-content">
                <div class="timeline-status">${escapeHTML(item.status)}</div>
                ${item.location ? `<div class="timeline-location">${escapeHTML(item.location)}</div>` : ''}
                ${item.time ? `<div class="timeline-time">${escapeHTML(item.time)}</div>` : ''}
              </div>
            `;
            timelineContainer.appendChild(li);
          });
        } else {
          const li = document.createElement('li');
          li.className = 'timeline-item';
          li.innerHTML = `
            <div class="timeline-icon"></div>
            <div class="timeline-content">
              <div class="timeline-status">Tracking details unavailable</div>
            </div>
          `;
          timelineContainer.appendChild(li);
        }
    }

    resultsContainer.classList.remove('hidden');
  }

  function escapeHTML(str) {
    if (!str) return '';
    return str.replace(/[&<>'"]/g, 
      tag => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;'
        }[tag] || tag)
    );
  }
}

// Run immediately for deferred scripts
initTracking();

// Listen for Shopify section reload (in Theme Editor)
document.addEventListener('shopify:section:load', initTracking);
